export function getUrlParamsBySearch(search = "") {
  let params = {};
  let obj = new URLSearchParams(search || window.location.search);
  // @ts-ignore
  for (let x of obj) {
    params[x[0]] = x[1];
  }
  return params;
}

/** 判断是否是问题类型，其中4为分页符，5为文本说明，应剔除 */
export function isQuestion(type) {
  return ["4", "5"].indexOf(type) < 0;
}

export function isEmpty(val) {
  switch (Object.prototype.toString.call(val)) {
    case "[object Array]":
      return !(val && val.length);
    case "[object Object]":
      return !(val && JSON.stringify(val) !== "{}");
    case "[object Null]":
      return true;
    case "[object Undefined]":
      return true;
    case "[object Boolean]":
      return true;
    default:
      return false;
  }
}
/**
 * 判断两个字符串或数字是否相同
 */
export function isSame(a, b) {
  return a?.toString() == b?.toString();
}
